export var locales = ['en', 'ru', 'it', 'es', 'de', 'zh', 'el'];
export var navbarTypes = ['date', 'unbordered'];
export var themes = ['b2b', 'b2c'];